import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';

// Memes routes (et memes parametres) que les *SearchInput de
// @mairistem/comptabilite : referentiel non caduque et non generique, lu
// page par page et filtre par la saisie (q)
const url = '/api/finances/comptabilite/imputations';

export type ElementReferentielImputation =
	| 'analytiques'
	| 'articles'
	| 'chapitres'
	| 'fonctions'
	| 'operations'
	| 'ventilations';

export interface ReferentielImputation {
	caduque?: boolean;
	code: string;
	identifiant: number;
	libelle?: string;
}

export const rechercherReferentiel = (
	element: ElementReferentielImputation,
	params: Record<string, string>,
	page: number,
	perPage: number,
	q: string,
) =>
	request.get<unknown, TemplateRequestGet<ReferentielImputation>>(
		`${url}/${element}/search?${new URLSearchParams({
			caduque: '0',
			generique: '0',
			page: String(page),
			perPage: String(perPage),
			q,
			...params,
		}).toString()}`,
	);
